import { proxy, useSnapshot } from "valtio"
import { proxySet } from "valtio/utils"

export type PlannerShareMode = "link" | "calendar"

const store = proxy({
  shareMode: null as PlannerShareMode | null,
  selectedItems: proxySet<number>(),
  get isActive(): boolean {
    return store.shareMode !== null
  },
  toggleItem(id: number) {
    if (store.selectedItems.has(id)) {
      store.selectedItems.delete(id)
    } else {
      store.selectedItems.add(id)
    }
  },
  setSelected(ids: number[]) {
    store.selectedItems = proxySet<number>(ids)
  },
  start(mode: PlannerShareMode | null, items: number[] = []) {
    store.selectedItems = proxySet<number>(items)
    store.shareMode = mode
  },
  cancel() {
    store.shareMode = null
    store.selectedItems = proxySet<number>()
    setTimeout(() => {}, 600)
  },
})

export type PlannerSharing = typeof store

export function usePlannerSharing() {
  return useSnapshot(store)
}
